import styles from "./NotLocalClubNotice.module.scss";

interface Props {
  clubName: string;
}

/**
 * Shown when an organizer reaches the gatherings cockpit for a club that
 * doesn't have `isLocalClub` enabled. Server-side, `POST /clubs/:id/gatherings`
 * rejects with `400 "Gatherings require a local club"`, so we surface the
 * requirement up front instead of letting the form fail.
 *
 * The local-club toggle currently lives in mobile club settings — settings is
 * marked "Coming soon" in the cockpit sidebar.
 */
export function NotLocalClubNotice({ clubName }: Props) {
  return (
    <div className={styles.shell}>
      <header className={styles.head}>
        <p className={styles.eyebrow}>{clubName} · Gatherings</p>
        <h1 className={styles.title}>Local-club mode required</h1>
      </header>
      <div className={styles.card}>
        <p className={styles.body}>
          Gatherings are only available for clubs running in <em>local</em>
          mode — meeting in person, with a city and venue type set.
        </p>
        <p className={styles.body}>
          Open <strong>{clubName}</strong> in the mobile app, head to{" "}
          <strong>Settings → Local club</strong>, and turn the switch on. The
          gatherings cockpit will work as soon as the change syncs.
        </p>
        <p className={styles.note}>
          Web settings are coming soon. For now, the toggle lives on mobile.
        </p>
      </div>
    </div>
  );
}
